import { render } from "./SupportWidget.vue?vue&type=template&id=f9767280&scoped=true"
import script from "./SupportWidget.vue?vue&type=script&lang=js"
export * from "./SupportWidget.vue?vue&type=script&lang=js"

import "./SupportWidget.vue?vue&type=style&index=0&id=f9767280&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9767280"]])

export default __exports__